module.exports = __webpack_public_path__ + "img/nazereen.98a12f5e.jpg";